var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 1315,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4686b8",
      stroke: "none"
    },
    d: "M299 264L487 264L487 263L467 263C520.023 205.434 568.834 143.464 619.729 84C641.086 59.0472 661.223 28.5056 686 7C679.043 3.65662 669.676 4.51086 662.089 3.65588C639.836 1.14771 617.386 0 595 0C529.372 0 462.647 1.81897 399 19.8596C368.162 28.6006 335.817 41.9581 317.699 70C299.739 97.7987 299 132.064 299 164L299 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M648 2L649 3L648 2M659 3L660 4L659 3M661 3L662 4L661 3M467 263L579 264L579 299L477 299C466.136 299 445.718 295.054 436.015 300.028C426.681 304.812 418.665 319.105 411.87 327C392.723 349.247 373.815 371.701 354.729 394C289.537 470.168 224.779 546.711 159.728 623C128.76 659.318 97.9784 695.803 66.8696 732C58.8656 741.313 50.7935 750.576 42.9198 760C40.1573 763.306 35.4058 767.345 35.4738 772C35.5509 777.287 39.5757 782.596 41.8488 787.174C48.0633 799.688 55.6583 811.529 64.9498 822C116.534 880.134 194.916 868 265 868L265 775C265 739.193 265.078 705.437 279.862 672C303.241 619.121 354.875 578.037 412 568.435C445.472 562.809 481.137 566 515 566L665 566C689.609 566 715.648 568.396 740 564.561C787.87 557.023 829.348 524.925 847.988 480C862.187 445.781 859 409.216 859 373L859 205C859 168.142 862.802 129.704 844.691 96C820.288 50.5881 772.644 19.5632 722 11.7253C712.034 10.183 696.13 4.13696 686.169 7.02856C679.715 8.90222 673.381 20.061 669.13 25C655.139 41.2563 641.331 57.6737 627.421 74C592.2 115.341 557.044 156.739 521.729 198C503.669 219.101 482.315 239.847 467 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4686b8",
      stroke: "none"
    },
    d: "M687 6L688 7L687 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M688 6L689 7L688 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4686b8",
      stroke: "none"
    },
    d: "M693 7L694 8L693 7M699 8L700 9L699 8M715 10L716 11L715 10M720.667 11.3334L721.333 11.6666L720.667 11.3334M731 13L732 14L731 13M742 16L743 17L742 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M400 19L401 20L400 19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4686b8",
      stroke: "none"
    },
    d: "M757 21L758 22L757 21M764 24L765 25L764 24M782 33L783 34L782 33M418 86.2863C447.722 82.6837 474.883 111.008 473.957 140C473.11 166.506 453.195 188.307 427 191.711C393.384 196.079 366.082 164.293 370.289 132C373.524 107.172 393.65 89.2375 418 86.2863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M307 91L308 92L307 91M385 101L386 102L385 101M374 117L375 118L374 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4686b8",
      stroke: "none"
    },
    d: "M853 118L854 119L853 118M34 772L35 772C42.0474 756.615 58.5487 742.94 69.4105 730C95.2994 699.157 121.545 668.593 147.729 638C210.083 565.148 271.917 491.852 334.271 419C357.049 392.387 379.816 365.758 402.424 339C413.545 325.838 426.273 313.225 436 299L245 299C201.813 299 158.348 295.834 118 314.309C53.3094 343.929 26.7573 403.312 12.7894 469C-9.16014 572.223 0.506401 672.456 34 772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M893 299C893 379.521 907.021 469.863 850.866 536C839.982 548.818 827.733 559.876 814 569.576C798.985 580.182 781.684 588.526 764 593.573C728.583 603.679 690.45 600 654 600L508 600C479.805 600 451.057 598.41 423 601.17C355.879 607.773 303.592 668.25 299.09 734C297.417 758.427 299 783.511 299 808L299 955C299 1006.99 295.752 1054.33 334.09 1095C363.535 1126.23 406.54 1143.18 447 1154.42C535.04 1178.9 626.045 1178.96 714 1153.71C759.861 1140.54 807.709 1120.75 836.845 1081C858.694 1051.19 859 1018.29 859 983L859 902L580 902L580 868L928 868C981.02 868 1040.08 876.308 1081.91 836.714C1109 811.078 1123.79 771.63 1135.33 737C1166.21 644.39 1164.32 553.594 1143.42 459C1132.55 409.756 1116.41 355.097 1075 322.668C1045.18 299.314 1010.98 299 975 299L893 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M130 309L131 310L130 309M52 367L53 368L52 367M42 382L43 383L42 382M38 389L39 390L38 389M29 408L30 409L29 408M22 428L23 429L22 428M12 470L13 471L12 470M9 485L10 486L9 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4686b8",
      stroke: "none"
    },
    d: "M427 566L428 567L427 566M381 576L382 577L381 576M376 578L377 579L376 578M357 587L358 588L357 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M0 612L1 613L0 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4686b8",
      stroke: "none"
    },
    d: "M318 616L319 617L318 616M306 629L305 631L306 629M279 672L280 673L279 672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M22 737L23 738L22 737M23 741L24 742L23 741M27 753L28 754L27 753M30 761L31 762L30 761M31 763L32 764L31 763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4686b8",
      stroke: "none"
    },
    d: "M35 773L36 774L35 773M36 776L37 777L36 776M38 780L40 782L38 780M41.3333 785.667L41.6667 786.333L41.3333 785.667M42 788L43 789L42 788M47 797L48 798L47 797M51 803L52 804L51 803M82 838L83 839L82 838M96 848L97 849L96 848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M735 974.325C790.036 970.22 806.296 1048.81 761 1073.69C754.622 1077.19 747.279 1079.4 740 1079.91C688.456 1083.52 664.212 1012.36 707 983.52C715.443 977.828 724.912 975.077 735 974.325M537 1262L537 1263L547 1263L537 1262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M282 1314L282 1315C290.258 1314.55 296.823 1307.94 304 1304.26C316.99 1297.6 332.493 1291.13 347 1289L347 1290C327.54 1292.86 306.885 1302.71 291 1314L291 1315L874 1315L874 1314C857.7 1303 837.7 1292.9 818 1290L818 1289C832.507 1291.13 848.01 1297.6 861 1304.26C868.189 1307.94 874.717 1314.73 883 1315C872.052 1303.87 854.529 1297.85 840 1293C807.564 1282.18 773.757 1276.55 740 1271.73C634.559 1256.66 523.363 1257.55 418 1272.73C372.362 1279.31 320.455 1286.67 282 1314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M618 1262L618 1263L628 1263L618 1262M513 1263L513 1264L520 1264L513 1263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M553 1263L553 1264L612 1264L593 1263L553 1263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M645 1263L645 1264L651 1264L645 1263M496 1264L496 1265L501 1265L496 1264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M523 1264L523 1265L545 1265L523 1264M620 1264L620 1265L642 1265L620 1264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M664 1264L664 1265L669 1265L664 1264M482 1265L482 1266L486 1266L482 1265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M504 1265L504 1266L519 1266L504 1265M646 1265L646 1266L661 1266L646 1265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M678 1265L678 1266L683 1266L678 1265M470 1266L470 1267L474 1267L470 1266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M489 1266L489 1267L501 1267L489 1266M548 1266L548 1267L552 1267L548 1266M613 1266L613 1267L617 1267L613 1266M664 1266L664 1267L676 1267L664 1266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M691 1266L691 1267L695 1267L691 1266M459 1267L459 1268L463 1268L459 1267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M476 1267L476 1268L487 1268L476 1267M522 1267L523 1268L522 1267M642 1267L643 1268L642 1267M678 1267L678 1268L688 1268L678 1267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M702 1267L702 1268L706 1268L702 1267M450 1268L450 1269L453 1269L450 1268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M465 1268L465 1269L474 1269L465 1268M504 1268L505 1269L504 1268M660 1268L661 1269L660 1268M690 1268L690 1269L700 1269L690 1268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M712 1268L712 1269L715 1269L712 1268M441.667 1269.33L442.333 1269.67L441.667 1269.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M455 1269L455 1270L464 1270L455 1269M489 1269L490 1270L489 1269M674.667 1269.33L675.333 1269.67L674.667 1269.33M701 1269L701 1270L710 1270L701 1269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M721 1269L721 1270L724 1270L721 1269M432 1270L432 1271L435 1271L432 1270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M446 1270L446 1271L454 1271L446 1270M477 1270L478 1271L477 1270M687 1270L688 1271L687 1270M711 1270L711 1271L719 1271L711 1270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M730 1270L730 1271L733 1271L730 1270M425.667 1271.33L426.333 1271.67L425.667 1271.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M430 1272L430 1273L445 1272L430 1272M466 1271L467 1272L466 1271M556 1271L556 1272L562 1272L556 1271M603 1271L603 1272L609 1272L603 1271M698 1271L699 1272L698 1271M720 1271L720 1272L727 1272L720 1271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M738.667 1271.33L739.333 1271.67L738.667 1271.33M417 1272L417 1273L420 1273L417 1272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M527 1272L527 1273L530 1273L527 1272M635 1272L635 1273L638 1273L635 1272M707 1272L708 1273L707 1272M728 1272L728 1273L735 1273L728 1272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M745 1272L745 1273L748 1273L745 1272M410 1273L410 1274L413 1274L410 1273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M409 1275L409 1276L429 1274L409 1275M448 1273L449 1274L448 1273M509.667 1273.33L510.333 1273.67L509.667 1273.33M654.667 1273.33L655.333 1273.67L654.667 1273.33M716 1273L717 1274L716 1273M736 1273L736 1274L762 1277L736 1273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M752.667 1273.33L753.333 1273.67L752.667 1273.33M404.667 1274.33L405.333 1274.67L404.667 1274.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M495.667 1274.33L496.333 1274.67L495.667 1274.33M668.667 1274.33L669.333 1274.67L668.667 1274.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M759.667 1274.33L760.333 1274.67L759.667 1274.33M398.667 1275.33L399.333 1275.67L398.667 1275.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M432 1275L433 1276L432 1275M483.667 1275.33L484.333 1275.67L483.667 1275.33M680.667 1275.33L681.333 1275.67L680.667 1275.33M732 1275L733 1276L732 1275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M765.667 1275.33L766.333 1275.67L765.667 1275.33M392.667 1276.33L393.333 1276.67L392.667 1276.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M403 1276L403 1277L408 1277L403 1276M425 1276L426 1277L425 1276M473 1276L474 1277L473 1276M691 1276L692 1277L691 1276M739 1276L740 1277L739 1276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M771.667 1276.33L772.333 1276.67L771.667 1276.33M386.667 1277.33L387.333 1277.67L386.667 1277.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M347 1288L347 1289L402 1278L385 1279.6L347 1288M418 1277L419 1278L418 1277M463 1277L464 1278L463 1277M700.667 1277.33L701.333 1277.67L700.667 1277.33M746 1277L747 1278L746 1277M763 1277L763 1278L818 1289C804.756 1280.91 778.426 1277.66 763 1277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M776.667 1277.33L777.333 1277.67L776.667 1277.33M381.667 1278.33L382.333 1278.67L381.667 1278.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M455 1278L456 1279L455 1278M709 1278L710 1279L709 1278M752 1278L753 1279L752 1278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M782.667 1278.33L783.333 1278.67L782.667 1278.33M376.667 1279.33L377.333 1279.67L376.667 1279.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M447 1279L448 1280L447 1279M717 1279L718 1280L717 1279M758 1279L759 1280L758 1279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M787.667 1279.33L788.333 1279.67L787.667 1279.33M371.667 1280.33L372.333 1280.67L371.667 1280.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M400 1280L401 1281L400 1280M439 1280L440 1281L439 1280M724 1280L725 1281L724 1280M764 1280L765 1281L764 1280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M792.667 1280.33L793.333 1280.67L792.667 1280.33M366.667 1281.33L367.333 1281.67L366.667 1281.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M433 1281L434 1282L433 1281M731 1281L732 1282L731 1281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M797 1281L798 1282L797 1281M362.667 1282.33L363.333 1282.67L362.667 1282.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M426 1282L427 1283L426 1282M738 1282L739 1283L738 1282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M801.667 1282.33L802.333 1282.67L801.667 1282.33M358 1283L359 1284L358 1283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M420 1283L421 1284L420 1283M744 1283L745 1284L744 1283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M805.667 1283.33L806.333 1283.67L805.667 1283.33M353.667 1284.33L354.333 1284.67L353.667 1284.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M380 1284L381 1285L380 1284M414 1284L415 1285L414 1284M784 1284L785 1285L784 1284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M810 1284L811 1285L810 1284M349.667 1285.33L350.333 1285.67L349.667 1285.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M409 1285L410 1286L409 1285M755 1285L756 1286L755 1285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M814 1285L815 1286L814 1285M346 1286L347 1287L346 1286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M371 1286L372 1287L371 1286M404 1286L405 1287L404 1286M760 1286L761 1287L760 1286M793 1286L794 1287L793 1286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M818 1286L819 1287L818 1286M342.667 1287.33L343.333 1287.67L342.667 1287.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M367 1287L368 1288L367 1287M399 1287L400 1288L399 1287M765 1287L766 1288L765 1287M797 1287L798 1288L797 1287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M821.667 1287.33L822.333 1287.67L821.667 1287.33M338.667 1288.33L339.333 1288.67L338.667 1288.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M363 1288L364 1289L363 1288M394 1288L395 1289L394 1288M801 1288L802 1289L801 1288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M825.667 1288.33L826.333 1288.67L825.667 1288.33M335.667 1289.33L336.333 1289.67L335.667 1289.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M287 1314L287 1315L308 1304.25L347 1290L330 1293.33L287 1314M359 1289L360 1290L359 1289M390 1289L391 1290L390 1289M774 1289L775 1290L774 1289M805 1289L806 1290L805 1289M818 1289L818 1290L857 1304.25L877 1315C866.222 1301.04 835.205 1290.5 818 1289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M828.667 1289.33L829.333 1289.67L828.667 1289.33M332 1290L333 1291L332 1290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M778 1290L779 1291L778 1290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M832 1290L833 1291L832 1290M328.667 1291.33L329.333 1291.67L328.667 1291.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M352 1291L353 1292L352 1291M782 1291L783 1292L782 1291M812 1291L813 1292L812 1291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M835 1291L836 1292L835 1291M325.667 1292.33L326.333 1292.67L325.667 1292.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M786 1292L787 1293L786 1292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M838.667 1292.33L839.333 1292.67L838.667 1292.33M322.667 1293.33L323.333 1293.67L322.667 1293.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M345 1293L346 1294L345 1293M374 1293L375 1294L374 1293M790 1293L791 1294L790 1293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M841 1293L842 1294L841 1293M320 1294L321 1295L320 1294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M342 1294L343 1295L342 1294M822 1294L823 1295L822 1294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M844 1294L845 1295L844 1294M317 1295L318 1296L317 1295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M339 1295L340 1296L339 1295M367 1295L368 1296L367 1295M797 1295L798 1296L797 1295M825 1295L826 1296L825 1295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M847 1295L848 1296L847 1295M314.667 1296.33L315.333 1296.67L314.667 1296.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M336 1296L337 1297L336 1296M800 1296L801 1297L800 1296M828 1296L829 1297L828 1296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M849.667 1296.33L850.333 1296.67L849.667 1296.33M312 1297L313 1298L312 1297M852 1297L853 1298L852 1297M309.667 1298.33L310.333 1298.67L309.667 1298.33M854.667 1298.33L855.333 1298.67L854.667 1298.33M307 1299L308 1300L307 1299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M328 1299L329 1300L328 1299M809 1299L810 1300L809 1299M836 1299L837 1300L836 1299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M857 1299L858 1300L857 1299M288 1309L288 1310L306 1301C300.266 1300.04 292.66 1305.93 288 1309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M352 1300L353 1301L352 1300M812 1300L813 1301L812 1300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M859 1300L860 1301L859 1300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M323 1301L324 1302L323 1301M349 1301L350 1302L349 1301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M861 1301L861 1302L872 1307L872 1306L861 1301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M321 1302L322 1303L321 1302M817 1302L818 1303L817 1302M843 1302L844 1303L843 1302M344 1303L345 1304L344 1303M845 1303L846 1304L845 1303M342 1304L343 1305L342 1304M822 1304L823 1305L822 1304M824 1305L825 1306L824 1305M311 1307L312 1308L311 1307M853 1307L854 1308L853 1307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M873 1307L873 1308L884 1315L873 1307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M309 1308L310 1309L309 1308M830 1308L831 1309L830 1308M855 1308L856 1309L855 1308M332 1309L333 1310L332 1309M832 1309L833 1310L832 1309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdf58",
      stroke: "none"
    },
    d: "M286 1310L281 1315L286 1310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a75a6",
      stroke: "none"
    },
    d: "M330 1310L331 1311L330 1310M834 1310L835 1311L834 1310M858 1310L859 1311L858 1310M303 1312L304 1313L303 1312M327 1312L328 1313L327 1312M837 1312L838 1313L837 1312M861 1312L862 1313L861 1312M300 1314L301 1315L300 1314M324 1314L325 1315L324 1314M840 1314L841 1315L840 1314z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.07330001e5c7d123bb4ab0f17da6855a.svg";
export { ForwardRef as ReactComponent };